import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const dialogContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => `${p.spacing(1.5)} !important`,
};
